import {
	whiteColor,
	dark_blue,
	cardBackground,
	grayColor,
	grayColorShade_5,
} from 'assets/jss/material-dashboard-pro-react';

const billPeriodSelectorStyle = (theme) => ({
	cell: {
		width: '28px',
		margin: 'auto',
		padding: '8px 0 6px',
	},
	billPeriodSelectorWrapper: {
		background: `${whiteColor}`,
		zIndex: '999',
		'& .MuiTab-textColorPrimary.Mui-selected': {
			background: cardBackground,
		},
		'& .MuiTab-root': {
			minWidth: '198px !important',
		},
		'& .MuiTabs-root': {
			background: `${whiteColor}`,
		},
		'& .rdtPicker': {
			width: '100%',
			boxShadow: `0px 24px 24px 0px ${dark_blue} !important`,
			borderRadius: '0px !important',
		},
		'& .form-control': {
			display: 'none !important',
		},
		'& .rdt': {
			position: 'absolute',
			top: '160px',
			width: '100%',
			left: 0,
		},
		'& .rdtMonths': {
			'& table:nth-child(2)': {
				display: 'flex',
				justifyContent: 'center',
			},
		},
		'& .rdtYears': {
			'& table:nth-child(2)': {
				display: 'flex',
				justifyContent: 'center',
			},
		},
		'& .rdtMonths .rdtMonth.rdtActive, .rdtMonths .rdtYear.rdtActive, .rdtYears .rdtMonth.rdtActive, .rdtYears .rdtYear.rdtActive, .rdtDay.rdtActive div, .rdtDay.rdtActive:hover div': {
			backgroundColor: `${cardBackground} !important`,
			color: 'inherit',
			boxShadow: 'none',
		},
		'& .rdtPicker td:hover': {
			backgroundColor: `${cardBackground} !important`,
		},
		'& .rdtActive': {
			backgroundColor: `${cardBackground} !important`,
		},
		'& .rdtMonths .rdtMonth, .rdtMonths .rdtYear, .rdtYears .rdtMonth, .rdtYears .rdtYear, .rdtDay.rdtActive div, .rdtDay.rdtActive:hover div': {
			borderRadius: '0px !important',
		},
	},
	[theme.breakpoints.between('sm', 'md')]: {
		billPeriodSelectorWrapper: {
			width: 'auto !important',
		},
	},
	[theme.breakpoints.up('md')]: {
		billPeriodSelectorWrapper: {
			width: 'auto !important',
			'& .rdt': {
				right: '0 !important',
				left: '0 !important',
				top: '160px',
			},
			'& .rdtPicker': {
				width: '100% !important',
				boxShadow: `0px 24px 24px 0px ${dark_blue} !important`,
				borderRadius: '0px !important',
			},
		},
	},
	customDateRangeWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	dateInputWrapper: {
		display: 'flex',
		justifyContent: 'space-between',
		background: grayColorShade_5,
		borderBottom: `1px  ${grayColor[0]} solid`,
		marginRight: '10px',
		'& .MuiSvgIcon-root': {
			position: 'relative',
			right: '22px',
			top: '2px',
		},
		'& .MuiTextField-root': {
			width: '100%',
			background: grayColorShade_5,
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none !important',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none !important',
		},
	},
	[theme.breakpoints.up('sm')]: {
		dateInputWrapper: {
			'& .MuiTextField-root': {
				padding: '10px',
			},
			'& .MuiSvgIcon-root': {
				top: '11px',
				right: '20px',
			},
		},
	},
});

export default billPeriodSelectorStyle;
